import { Injectable } from '@angular/core';
import { isNumber } from '../utils/functions';

@Injectable({
	providedIn: 'root'
})
export class DateService {

	public static transformerTimestampEnDate(date: Date | number): Date {
		return isNumber(date) ? new Date(date) : date as Date;
	}

	public transformDateToIsoString(date: Date): string {
		const isoDateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
		return isoDateTime.toISOString().slice(0, 10);
	}

	/**
	 * Renvoie un tableau des dates comprises entre les dates fournies en paramètre.
	 * @param dateDebut la première date de l'intervalle (incluse)
	 * @param dateFin la dernière date de l'intervalle (incluse)
	 * @return {Date[]} un tableau contenant les dates comprises dans l'intervalle.
	 */
	public joursPourIntervalle(dateDebut, dateFin): Date[] {
		const momentDebut = new Date(dateDebut);
		momentDebut.setHours(0, 0, 0, 0);
		const momentFin = new Date(dateFin);
		momentFin.setHours(0, 0, 0, 0);

		const span = Math.ceil((momentFin.getTime() - momentDebut.getTime()) / (1000 * 60 * 60 * 24));
		const datesIntervalle = [];
		for (let i = 0; i <= span; i++) {
			const nouvelleDate = new Date(dateDebut.getTime());
			nouvelleDate.setDate(nouvelleDate.getDate() + i);
			datesIntervalle.push(nouvelleDate);
		}
		return datesIntervalle;
	}

	/**
	 * Renvoie true si les deux dates sont de la même journée, false sinon
	 * @param date1 la première date
	 * @param date2 la deuxième date
	 */
	public sontDatesMemeJour(date1: Date, date2: Date): boolean {
		if (date1 || date2) {
			if (date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate()) {
				return true;
			}
		}
		return false;
	}
}
